export default (function (event) {
    return Boolean(event.touches && event.touches.length);
});
